import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from '../app/translation/en.json';

export const defaultNS = 'translation';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: 'en',
    defaultNS,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en,
    },
  })
  .catch(() => {});

if (i18n.services.formatter) {
  i18n.services.formatter.add(
    'capitalize',
    (value = '') => `${value.substr(0, 1).toUpperCase()}${value.substr(1)}`,
  );
}

export default i18n;
